import { supabase } from "./supabase";

export async function fetchCategories() {
  const { data, error } = await supabase.from("categories").select("*");
  if (error) throw new Error(error.message);
  return data || [];
}

export async function fetchProducts({ category, featured } = {}) {
  let query = supabase.from("products").select("*").order("created_at", { ascending: false });
  
  if (category) {
    query = query.eq("category", category);
  }
  if (featured !== undefined) {
    query = query.eq("is_featured", featured);
  }
  
  const { data, error } = await query;
  if (error) throw new Error(error.message);
  return data || [];
}

export async function fetchProduct(id) {
  const { data, error } = await supabase.from("products").select("*").eq("id", id).single();
  if (error) throw new Error(error.message);
  return data;
}


export async function addToCart(user_id, product_id) {
  try {
    const { data, error } = await supabase
      .from("cart_items")
      .upsert({ user_id, product_id }, { onConflict: "user_id,product_id" });
    if (error) throw error;
    return data;
  } catch (err) {
    console.error("Cart Add Error:", err.message);
    return null;
  }
}

export async function getCart(user_id) {
  try {
    const { data, error } = await supabase
      .from("cart_items")
      .select(`
        id, created_at,
        product:products (*)
      `)
      .eq("user_id", user_id)
      .order("created_at", { ascending: false });
    if (error) throw error;
    return data || [];
  } catch (err) {
    console.error("Cart Fetch Error:", err.message);
    return [];
  }
}

export async function removeFromCart(user_id, product_id) {
  try {
    const { error } = await supabase
      .from("cart_items")
      .delete()
      .eq("user_id", user_id)
      .eq("product_id", product_id);
    if (error) throw error;
  } catch (err) {
    console.error("Cart Remove Error:", err.message);
  }
}

export async function addViewHistory(user_id, product_id) {
  try {
    const { error } = await supabase
      .from("view_history")
      .upsert({ user_id, product_id, viewed_at: new Date().toISOString() }, { onConflict: "user_id,product_id" });
    if (error) throw error;
  } catch (err) {
    console.error("View History Add Error:", err.message);
  }
}

export async function getViewHistory(user_id) {
  try {
    const { data, error } = await supabase
      .from("view_history")
      .select(`
        id, viewed_at,
        product:products (*)
      `)
      .eq("user_id", user_id)
      .order("viewed_at", { ascending: false })
      .limit(10);
    if (error) throw error;
    return data || [];
  } catch (err) {
    console.error("View History Fetch Error:", err.message);
    return [];
  }
}
